import React from "react";

const EvolutionSection = () => {
  return (
    <>
      {/* Horizontal Scroll Section */}
      <div
        className="mt-12 overflow-hidden relative"
        style={{ background: "#418cff", color: "white", padding: "1rem 0" }}
      >
        {/* Internal styles for animation */}
        <style>
          {`
           @keyframes scroll-horizontal {
             0% {
               transform: translateX(0);
             }
             100% {
               transform: translateX(-100%);
             }
           }
           .scrolling-wrapper {
             display: flex;
             animation: scroll-horizontal 20s linear infinite;
           }
           .scrolling-content {
             display: flex;
             white-space: nowrap;
           }
         `}
        </style>

        {/* Scrolling Content */}
        <div className="scrolling-wrapper">
          <div className="scrolling-content flex gap-8">
            <span className="text-sm">
              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>
              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>

              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>

              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>
            </span>
          </div>
        </div>
      </div>
      {/* Horizontal Scroll Section */}
      <div
        className="mt-2 overflow-hidden relative mb-12"
        style={{ background: "black", color: "white", padding: "1rem 0" }}
      >
        {/* Internal styles for animation */}
        <style>
          {`
           @keyframes scroll-horizontal {
             0% {
               transform: translateX(0);
             }
             100% {
               transform: translateX(-100%);
             }
           }
           .scrolling-wrapper-second {
             display: flex;
             animation: scroll-horizontal 60s linear infinite;
           }
           .scrolling-content {
             display: flex;
             white-space: nowrap;
           }
         `}
        </style>

        {/* Scrolling Content */}
        <div className="scrolling-wrapper-second ">
          <div className="scrolling-content flex gap-8">
            <span className="text-sm">
              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>

              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>
              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>
              <span className="mx-2">&bull; Sign Board </span>
              <span className="mx-2">&bull; ACP Sign Board </span>
              <span className="mx-2">&bull; Eco Solvent Print </span>
              <span className="mx-2">&bull; 3D Letter </span>
              <span className="mx-2">&bull; UV Print </span>
              <span className="mx-2">&bull; Latex Print </span>
              <span className="mx-2">&bull; Lollipop Signage </span>
            </span>
            {/* Duplicate content for seamless loop */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EvolutionSection;
